import closeIcon from "../assets/newCloseIcon.png";

const CloseTrailer = () => {
  return (
    <span>
      <img src={closeIcon} alt="" width={12} height={12} />
    </span>
  )
}

export default CloseTrailer;
